<template>
  <v-card outlined class="pa-4 ma-0 d-flex flex-column gap-3" style="height: 350px">
    <!-- Header -->
    <v-container class="pa-0 ma-0 d-flex justify-space-between align-center gap-2">
      <v-container class="pa-0 ma-0 d-flex flex-column gap-2 text-right rtl">
        <v-card-text class="pa-0 ma-0 text-body-1">
          {{ $t("unpassedCheck") }}
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2 gray--text" style="color: #717182">
          {{ $t("payCheckList") }}
        </v-card-text>
      </v-container>
      <v-btn text small color="primary" class="ma-0 pa-0">
        {{ $t("viewAll") }}
        <v-icon small class="ma-0 pa-0">mdi-chevron-left</v-icon>
      </v-btn>
    </v-container>

    <!-- List -->
    <v-list
      v-if="PayCheckArray && PayCheckArray.length > 0"
      dense
      class="pa-0 ma-0 scroll-y"
    >
      <v-list-item
        v-for="(PayCheck, index) in PayCheckArray"
        :key="index"
        class="pa-0 ma-0"
      >
        <!-- Avatar -->
        <v-list-item-avatar size="38" class="square-avatar">
          <v-img v-if="PayCheck.avatar" :src="PayCheck.avatar" contain />
          <v-avatar v-else color="grey lighten-3">
            <v-icon color="grey"> mdi-file-document </v-icon>
          </v-avatar>
        </v-list-item-avatar>

        <!-- Info -->
        <v-list-item-content class="pa-0 ma-0">
          <v-list-item-title class="pa-0 pt-1 ma-0 text-body-1">
            {{ PayCheck.account.name }}
          </v-list-item-title>

          <v-list-item-subtitle class="pa-0 ma-0 py-1 text-body-2 grey--text">
            #{{ PayCheck.number }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <!-- date -->
        <v-list-item-content class="pa-0 ma-0">
          <v-list-item-title class="pa-0 pt-1 ma-0 text-body-1">
            {{ PayCheck.due_date }}
          </v-list-item-title>

          <v-list-item-subtitle class="pa-0 ma-0 py-1 text-body-2 grey--text">
            {{ resolveRemainDays(PayCheck) }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <!-- Amount -->
        <v-list-item-action>
          <v-container class="d-flex pa-0 ma-0 text-left">
            <v-card-text class="pa-0 ma-0 text-body-1">
              {{ formatPrice(PayCheck.amount) }}
            </v-card-text>
            <v-card-text class="pa-0 ma-0 py-1 text-body-2 grey--text">{{
              $store.state.currency.name
            }}</v-card-text>
          </v-container>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-container
      v-else
      class="pa-0 ma-0 d-flex flex-column align-center justify-center"
      style="height: 337px"
    >
      <img
        :src="require('@/assets/dashboard/no-data(3).png')"
        max-width="100"
        height="100"
        contain
        class="mb-3"
      />
      <v-card-text class="text-body-2 grey--text text-center">
        {{ $t("nothing-for-render") }}
      </v-card-text>
    </v-container>
  </v-card>
</template>
<script>
import moment from "moment-jalaali";

export default {
  name: "invoicelistPending",
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      PayCheckArray: [],
      checkType: "payCheck",
      options: {
        itemsPerPage: 10,
        page: 1,
      },
      loading: false,
    };
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.this.getUnpassedCheckData();
        newVal;
      },
    },

    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getUnpassedCheckData(newVal);
      },
    },
  },
  mounted() {
    this.getUnpassedCheckData();
  },
  methods: {
    resolveRemainDays(value) {
      const today = moment().startOf("day");
      const due = moment(value.due_date, "jYYYY/jMM/jDD");
      const diffDays = due.diff(today, "days");
      return diffDays > 0 ? `${diffDays} ${this.$t("days-left")}` : "پایان مهلت";
    },
    formatPrice(value) {
      if (value === null || value === undefined) return "-";
      return this.$numberFormat(value);
    },
    getUnpassedCheckData(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "checks", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
            options: app.options,
            type: this.checkType,
          },
        })
        .then((response) => {
          let res = response.data?.data || [];
          app.PayCheckArray = res.slice(0, 10);
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.square-avatar {
  border-radius: 2px !important;
}
.scroll-y {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-scrollbar: none;
}
</style>
